
import { AuthenticationService } from '@/apiConnection/authentication.service';
import { LoadingComponent } from '@/components/loading/loading.component';
import { PasswordToggleComponent } from '@/components/password-toggle/password-toggle.component';
import { ChangeDetectorRef, Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  imports: [
    ReactiveFormsModule,
    RouterModule,
    LoadingComponent,
    PasswordToggleComponent,
  ],
  templateUrl: './login.page.html',
  styleUrl: './login.page.scss',
})
export class LoginPage {
  loading = false;
  isProduction = environment.production;

  login = new FormGroup({
    // email or username
    user: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required])
  });

  error = false;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private cdr: ChangeDetectorRef
  ) {
    if (localStorage.getItem('currentUser')) {
      // return to home if user is logged
      this.router.navigate(['/']);
    }
  }

  onSubmit() {
    if (this.login.valid) {
      this.loading = true;

      const { user, password } = this.login.value;

      this.authenticationService.login(user?.trim(), password).subscribe({
        next: data => {

          this.router.navigate([sessionStorage.getItem('returnUrl') ?? '/'])

        },
        error: () => {
          this.error = true;
          this.loading = false;
          this.cdr.detectChanges()
        }
      })

    } else {
      this.error = true;
      this.cdr.detectChanges()
    }
  }
}
